module.exports = __webpack_public_path__ + "img/methods (8).274f1fee.png";